
import { useState, FormEvent } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    direccion: '',
    tamano: '',
    fecha: '',
    mensaje: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d5rjpootu5df1co4dja0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nombre: '',
          email: '',
          telefono: '',
          direccion: '',
          tamano: '',
          fecha: '',
          mensaje: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contacto" className="py-12 sm:py-16 md:py-20 bg-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
            Solicita tu presupuesto gratuito
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto px-4">
            Rellena el formulario y te contactaremos en menos de 24 horas con un presupuesto personalizado sin compromiso. Conoce todos nuestros <a href="#servicios" className="text-teal-600 hover:text-teal-700 font-semibold underline cursor-pointer">servicios de vaciado</a> disponibles.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12">
          <div>
            <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-5 sm:space-y-6">
              <div>
                <label htmlFor="nombre" className="block text-sm font-medium text-gray-700 mb-2">
                  Nombre completo *
                </label>
                <input
                  type="text"
                  id="nombre"
                  name="nombre"
                  required
                  value={formData.nombre}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-teal-600 focus:border-transparent text-sm"
                  placeholder="Tu nombre"
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 sm:gap-6">
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-teal-600 focus:border-transparent text-sm"
                    placeholder="tu@email.com"
                  />
                </div>

                <div>
                  <label htmlFor="telefono" className="block text-sm font-medium text-gray-700 mb-2">
                    Teléfono *
                  </label>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    required
                    value={formData.telefono}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-teal-600 focus:border-transparent text-sm"
                    placeholder="629 501 941"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="direccion" className="block text-sm font-medium text-gray-700 mb-2">
                  Dirección del piso *
                </label>
                <input
                  type="text"
                  id="direccion"
                  name="direccion"
                  required
                  value={formData.direccion}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-teal-600 focus:border-transparent text-sm"
                  placeholder="Calle, número, piso, Barcelona"
                />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 sm:gap-6">
                <div>
                  <label htmlFor="tamano" className="block text-sm font-medium text-gray-700 mb-2">
                    Tamaño del piso *
                  </label>
                  <select
                    id="tamano"
                    name="tamano"
                    required
                    value={formData.tamano}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-teal-600 focus:border-transparent text-sm cursor-pointer"
                  >
                    <option value="">Selecciona...</option>
                    <option value="40-60m2">40-60 m² (1-2 hab.)</option>
                    <option value="60-90m2">60-90 m² (2-3 hab.)</option>
                    <option value="90+m2">90+ m² (3+ hab.)</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="fecha" className="block text-sm font-medium text-gray-700 mb-2">
                    Fecha deseada
                  </label>
                  <input
                    type="date"
                    id="fecha"
                    name="fecha"
                    value={formData.fecha}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-teal-600 focus:border-transparent text-sm"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="mensaje" className="block text-sm font-medium text-gray-700 mb-2">
                  Mensaje adicional
                </label>
                <textarea
                  id="mensaje"
                  name="mensaje"
                  rows={4}
                  maxLength={500}
                  value={formData.mensaje}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-teal-600 focus:border-transparent text-sm resize-none"
                  placeholder="Cuéntanos más detalles sobre tu vaciado..."
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">Máximo 500 caracteres</p>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? 'Enviando...' : 'Solicitar Presupuesto Gratis'}
              </button>

              {submitStatus === 'success' && (
                <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg text-sm">
                  ¡Gracias! Hemos recibido tu solicitud. Te contactaremos pronto.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg text-sm">
                  Ha ocurrido un error. Por favor, inténtalo de nuevo o llámanos directamente.
                </div>
              )}
            </form>

            <div className="mt-6 text-center">
              <p className="text-xs text-gray-500">
                Al enviar este formulario, aceptas nuestra <a href="/politica-privacidad" className="text-teal-600 hover:text-teal-700 underline cursor-pointer">política de privacidad</a> y el uso de <a href="/politica-cookies" className="text-teal-600 hover:text-teal-700 underline cursor-pointer">cookies</a>.
              </p>
            </div>
          </div>

          <div className="space-y-6 sm:space-y-8">
            <div className="bg-white rounded-xl p-6 sm:p-8 shadow-sm">
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-5 sm:mb-6">
                Información de Contacto
              </h3>
              <div className="space-y-5 sm:space-y-6">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-xl sm:text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">Teléfono</h4>
                    <a href="tel:629501941" className="text-teal-600 hover:text-teal-700 cursor-pointer text-sm sm:text-base break-all">
                      629 501 941
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-xl sm:text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">Zona de Servicio</h4>
                    <p className="text-gray-600 text-sm sm:text-base">Barcelona y área metropolitana</p>
                  </div>
                </div>

                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-xl sm:text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1 text-sm sm:text-base">Horario</h4>
                    <p className="text-gray-600 text-sm sm:text-base">Lunes a Sábado: 8:00 - 20:00</p>
                    <p className="text-gray-600 text-sm sm:text-base">Domingos: Consultar</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-teal-600 rounded-xl p-6 sm:p-8 text-white">
              <h3 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">¿Por qué elegir VPB?</h3>
              <ul className="space-y-2 sm:space-y-3">
                <li className="flex items-start gap-2 sm:gap-3">
                  <i className="ri-check-line text-lg sm:text-xl flex-shrink-0 mt-0.5"></i>
                  <span className="text-xs sm:text-sm">Más de 10 años de experiencia en Barcelona</span>
                </li>
                <li className="flex items-start gap-2 sm:gap-3">
                  <i className="ri-check-line text-lg sm:text-xl flex-shrink-0 mt-0.5"></i>
                  <span className="text-xs sm:text-sm">Equipo profesional y certificado</span>
                </li>
                <li className="flex items-start gap-2 sm:gap-3">
                  <i className="ri-check-line text-lg sm:text-xl flex-shrink-0 mt-0.5"></i>
                  <span className="text-xs sm:text-sm">Precios transparentes sin sorpresas</span>
                </li>
                <li className="flex items-start gap-2 sm:gap-3">
                  <i className="ri-check-line text-lg sm:text-xl flex-shrink-0 mt-0.5"></i>
                  <span className="text-xs sm:text-sm">Gestión responsable de residuos</span>
                </li>
                <li className="flex items-start gap-2 sm:gap-3">
                  <i className="ri-check-line text-lg sm:text-xl flex-shrink-0 mt-0.5"></i>
                  <span className="text-xs sm:text-sm">Servicio rápido y eficiente</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
